import { Alert } from "reactstrap";
import { useState, useEffect } from "react";

const NotificationAlert = ({ alert, onClose }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (alert.show) {
            setVisible(true);
            const timer = setTimeout(() => {
                setVisible(false);
                if (onClose) {
                    setTimeout(onClose, 300); // Wait for fade out animation
                }
            }, alert.duration || 3000);

            return () => clearTimeout(timer);
        }
    }, [alert.show, alert.duration, onClose]);

    if (!alert.show) return null;

    return (
        <Alert
            color={alert.color}
            className={`mb-4 alert-dismissible fade ${visible ? "show" : ""}`}
            isOpen={visible}
            toggle={() => {
                setVisible(false);
                if (onClose) {
                    setTimeout(onClose, 300);
                }
            }}
        >
            <span className="alert-inner--icon">
                <i
                    className={`ni ${
                        alert.color === "success"
                            ? "ni-like-2"
                            : "ni-support-16"
                    }`}
                ></i>
            </span>
            <span className="alert-inner--text">
                <strong>
                    {alert.color === "success" ? "Success!" : "Error!"}
                </strong>{" "}
                {alert.message}
            </span>
        </Alert>
    );
};

export default NotificationAlert;
